import { User, UserInterface } from 'app/core/user/models';
import { Base64DecodePipe } from 'app/shared/pipes/base64-decode.pipe';

export interface NotificationInterface {
  id?: number;
  templateId?: number;
  originTaskId?: number;
  originTaskTitle?: string;
  title?: string;
  message?: string;
  notificationDate?: Date;
  read?: boolean;
  wasEmailSent?: boolean;
  subject?: UserInterface;
  messageAsHtml?: string;
}

export class Notification implements NotificationInterface {
  public id?: number;
  public templateId?: number;
  public originTaskId?: number;
  public originTaskTitle?: string;
  public title?: string;
  public message?: string;
  public notificationDate?: Date;
  public read?: boolean;
  public wasEmailSent?: boolean;
  public subject?: UserInterface;

  constructor({
    id = undefined,
    templateId = undefined,
    originTaskId = undefined,
    originTaskTitle = undefined,
    title = undefined,
    message = undefined,
    notificationDate = undefined,
    read = undefined,
    wasEmailSent = undefined,
    subject = undefined,
  }: NotificationInterface) {
    this.id = id;
    this.templateId = templateId;
    this.originTaskId = originTaskId;
    this.originTaskTitle = originTaskTitle;
    this.title = title;
    this.message = message;
    this.notificationDate = notificationDate;
    this.read = read;
    this.wasEmailSent = wasEmailSent;
    this.subject = subject ? new User(subject) : undefined;
  }

  get messageAsHtml(): string {
    return new Base64DecodePipe().transform(this.message);
  }
}
